import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { ModalCloseButton } from '@/components/ui/modal-close-button/modal-close-button.component';
import { SheetClose, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { startPendingSignup } from '@/store/pending-signup.store';
import { useProgressiveModal } from '@/components/ui/progressive-modal/progressive-modal.hook';
import LoginForm from '@/app/(main)/_components/sign-in-modal/_components/login-form.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { LoginAnalyticsEnum } from '@/types/enums/analytics/login/login-analytics.enum';
import { modalsOpeningStore, setOpenSignInModal } from '@/store/modal';
import { trackLoginModalEvent } from '@/utils/auth/login-analytics.util';

export default function LoginStep() {
  const { onClose } = useProgressiveModal();
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const handleCreateAccount = () => {
    trackLoginModalEvent(LoginAnalyticsEnum.LOGIN_CLICK_REGISTER);
    startPendingSignup(modalsOpeningStore.getState().signInModalOrigin);
    setOpenSignInModal(false);

    const query = searchParams?.toString();
    const returnUrl = query ? `${pathname}?${query}` : pathname;

    router.push(`/cadastro/?returnUrl=${encodeURIComponent(returnUrl)}`);
  };

  const handleClose = () => {
    trackLoginModalEvent(LoginAnalyticsEnum.LOGIN_CLOSE_MODAL);
    onClose?.();
  };

  return (
    <div className="flex flex-col h-full md:max-h-[40rem]" data-testid={DataTestIdEnum.LOGIN_STEP}>
      <SheetHeader className="bg-white">
        <div className="flex justify-between gap-3 pb-4 items-center">
          <div className="flex gap-3">
            <SheetTitle>
              <div className="flex gap-3">
                <Typography variant={TypographyVariant.MODAL_TITLE}>Entrar</Typography>
              </div>
            </SheetTitle>
          </div>
          <SheetClose
            asChild
            data-testid={DataTestIdEnum.LOGIN_CLOSE_BUTTON}
            className="self-center"
            onClick={handleClose}
          >
            <ModalCloseButton skipInitialFocus />
          </SheetClose>
        </div>
      </SheetHeader>
      <div className="flex flex-col gap-6">
        <LoginForm />
        <div className="flex flex-col items-center gap-1">
          <p className="text-gray-800 font-normal leading-5">Ainda não possui conta?</p>
          <p
            data-testid={DataTestIdEnum.LOGIN_REGISTER_LINK}
            className="text-green-500 font-semibold leading-6 cursor-pointer"
            onClick={handleCreateAccount}
          >
            Cadastre-se
          </p>
        </div>
      </div>
    </div>
  );
}
